module.exports = __webpack_public_path__ + "img/freecool.62ed932e.svg";